import { useEffect } from 'react'
import { siteContent } from '../content/siteContent'

const WIDGET_NOTICE_ID = '52468'
const WIDGET_TYPE = 'type3'
const WIDGET_SCRIPT_ID = 'wzk-widget-script'
const WIDGET_SCRIPT_URL = 'https://widgets.4wzk.pl/dist/js/widget.js'
const WIDGET_PROVIDER_URL = 'https://www.weselezklasa.pl/'
const WIDGET_LOGO_URL = 'https://widgets.4wzk.pl/dist/img/footer-logo.svg'

export function ReviewsWidget() {
  useEffect(() => {
    const widgetWindow = window as Window & { wzkWigetLoaded?: boolean }

    // React renders the iframe; the official script handles responsive height messages.
    widgetWindow.wzkWigetLoaded = true
    if (document.getElementById(WIDGET_SCRIPT_ID)) return

    const script = document.createElement('script')
    script.id = WIDGET_SCRIPT_ID
    script.src = WIDGET_SCRIPT_URL
    script.defer = true
    document.body.appendChild(script)
  }, [])

  return (
    <div
      className="reviews-widget wzk-widget iframe-height"
      data-wzk-widget-type={WIDGET_TYPE}
      data-wzk-notice={WIDGET_NOTICE_ID}
    >
      <iframe
        src={siteContent.reviewsWidgetUrl}
        title="Opinie o oprawie wokalnej Kasi Staszewskiej w serwisie Wesele z klasą"
      />
      <div className="reviews-widget__footer">
        <a
          className="wzk-accent-color"
          title="Śpiew na ślubie - Kasia Staszewska - zobacz więcej opinii"
          href={siteContent.reviewsUrl}
          target="_blank"
          rel="noreferrer"
        >
          <span>Śpiew na ślubie - Kasia Staszewska - </span>zobacz więcej opinii
        </a>
        <a href={WIDGET_PROVIDER_URL} title="Wesele z klasą" target="_blank" rel="noreferrer">
          <img src={WIDGET_LOGO_URL} alt="Wesele z klasą" />
        </a>
      </div>
    </div>
  )
}
